import { render } from "./BottomBar.vue?vue&type=template&id=7e7bd9de&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=js"
export * from "./BottomBar.vue?vue&type=script&lang=js"

import "./BottomBar.vue?vue&type=style&index=0&id=7e7bd9de&lang=scss&scoped=true"

import exportComponent from "E:\\developYZ\\yzWebsite\\newWebsite\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7bd9de"]])

export default __exports__